import React from 'react'
import Navbar from './Navbar'
import { Box,List,  ListItem, Typography, Card, Grid  } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
const ListPage=({
  ListContent=["L1","L2","L3"], 
  Title='TitleName', 
  ImageLoc="/imgs/Bg1.jpg", 
  ListNumber=Math.ceil(ListContent.length / 2)

})=> {


  return (
    <div>
        <Box top={0} position={'sticky'}><Navbar/></Box>
        <Box overflow={'hidden'} sx={{ zIndex:'-12', position: 'relative',  height: '50vh' }}>
          <img
            src={ImageLoc}
            alt="Background "
            style={{
              objectFit:'cover',
              width: '100%',
              height: '100%',
            }}
          />
          
            <Typography variant='h3'   color={'primary.main'}  sx={{py:2, backgroundColor:'rgba(0,0,0,0.5)',  position: 'absolute', bottom: 0, width:1 }}>
              {Title}
            </Typography>
       </Box>
      <Grid container spacing={4}  sx={{ display: 'flex',  p:'3%' }}>


        {/* Column 1 */}
        <Grid item xs={12} lg={6}>
          <Card sx={{backgroundColor:'primary.light'}}>
            <List >
              {ListContent.slice(0, ListNumber).map((item, key) => (
                <ListItem key={key} sx={{ p: 2 }}>
          
                    <ArrowRightIcon color='primary.light' fontSize='large' />
          
                  <Typography fontWeight={'bold'}>{item}</Typography>
                </ListItem>
              ))}
            </List>
          </Card>
        </Grid>

        {/* Column 2 */}
        <Grid item xs={12} lg={6}>
          <Card sx={{backgroundColor:'primary.light'}}>
            <List >
              {ListContent.slice(ListNumber).map((item, key) => (
                <ListItem key={key} sx={{ p: 2,}}>
          
                    <ArrowRightIcon color='primary.light' fontSize='large' />
          
                  <Typography fontWeight={'bold'}>{item}</Typography>
                </ListItem>
              ))}
            </List>
          </Card>
        </Grid>
      </Grid>

    </div>
  )
}
export default ListPage